import { Component, OnInit, HostListener,PLATFORM_ID,Inject } from '@angular/core';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { Router } from '@angular/router';

@Component({
  selector: 'app-offer-registration-form',
  templateUrl: './offer-registration-form.component.html',
  styleUrls: ['./offer-registration-form.component.scss']
})
export class OfferRegistrationFormComponent implements OnInit {

  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;

  @HostListener('input') oninput() {
    if (this.contactForm.valid) {
      this.disabledSubmitButton = false;
    }
  }

  constructor(
    private fb: FormBuilder,
    private networkCall: WebsiteService,
    private toastr: ToastrService,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
     private router: Router
    // private shareService: SharedService

  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'spocDesignation': ['', Validators.required],
      'institutionName': ['', Validators.required],
      'institutionDomain': ['', [Validators.required, this.domainValidator]],
      'contactSalesRep': ['', Validators.required],
    });
  }

  domainValidator(control: FormControl): { [key: string]: any } | null {
    const regex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
    const valid = regex.test(control.value);
    return valid ? null : { invalidDomain: true };
  }

  ngOnInit(): void {
    this.titleService.setTitle('Offer Registration Form');
    this.metaTagService.updateTag({ name: 'description', content: "Offer Registration Form" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Offer Registration Form' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Offer Registration Form' });
    this.metaTagService.updateTag({ name: 'robots', content: 'noindex, nofollow' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/cwg-university-offer' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/cwg-university-offer' });

  }

  processForm() {
    // console.log("gggg")
    // if(this.contactForm.value.contactFormEmail && this.contactForm.value.contactFormName && this.contactForm.value.contactFormSubjects && this.contactForm.value.contactFormMessage){
    if (this.contactForm.valid) {
      // console.log("vlaidated")
      const selectedQueryType = this.contactForm.value.contactFormQueryType;
      var query = this.contactForm.value.contactFormName + "||" + this.contactForm.value.spocDesignation + "||" + this.contactForm.value.institutionName + "||" + this.contactForm.value.institutionDomain + "||" + this.contactForm.value.contactSalesRep
      this.networkCall.postContactUs(this.contactForm.value.contactFormEmail, query,  this.router.url).subscribe(result => {
        this.toastr.success("感谢您，我们会尽速和您联络")
        this.contactForm.reset();
      }, error => {
        // this.shareService.errorHandller(error);
      })
    } else {
      // this.toastr.warning("Please fill in the necessary details on the form.")
      this.validateAllFormFields(this.contactForm);
    }
    // const allInfo = `My name is ${this.name}. My email is ${this.email}. My message is ${this.message}`;
    // alert(allInfo);
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

}
